// 导入 mitt
import mitt from 'mitt'

// 创建 mitt 实例，作为事件总线
const eventBus = mitt()

// 导出实例，供组件使用
export default eventBus